import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../shared/alert/alert.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../shared/service/param.context';
import { HelpService } from '../shared/service/help.service';
import { UrlService } from '../shared/service/url.service';
import { HELP_MULTI_SITE_ANALYSIS } from '../app.constants';
import { StudyManagerTreeComponent } from '../study-manager/study-manager-tree.component';
import { HttpResponse } from '@angular/common/http';
import { DatasetModel } from '../shared/dataset/model/dataset.model';
import { DatasetTypeEnum } from '../shared/dataset/model/dataset-type.enum';
import { DatasetService } from '../shared/dataset/service/dataset.service';
import { NavTab } from '../shared/nav/tab/nav-tab.model';
import { JhiEventManager, JhiLanguageService } from '../shared/core-utils';
import { ObservationVariable } from '../shared/model/observation-variable.model';
import { VariableTypeEnum } from '../shared/ontology/variable-type.enum';

@Component({
    selector: 'jhi-multi-site-analysis',
    templateUrl: './multi-site-analysis.component.html'
})
export class MultiSiteAnalysisComponent implements OnInit {

    helpLink: string;
    tabs: NavTab[] = [];

    constructor(private route: ActivatedRoute,
                private eventManager: JhiEventManager,
                private languageService: JhiLanguageService,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private modalService: NgbModal,
                private paramContext: ParamContext,
                private helpService: HelpService,
                private router: Router,
                private urlService: UrlService,
                private datasetService: DatasetService) {
        this.paramContext.readParams();
    }

    ngOnInit() {
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_MULTI_SITE_ANALYSIS).toPromise().then((response) => {
                this.helpLink = response.body;
            }).catch((error) => {
            });
        }
    }

    browseStudy($event) {
        $event.preventDefault();
        const studyTreeComponent = this.modalService.open(StudyManagerTreeComponent, { modalDialogClass: 'modal-md', backdrop: 'static' });
        studyTreeComponent.componentInstance.hideViewSummaryButton = true;
        studyTreeComponent.result.then((studies) => {
            if (studies && studies.length === 1) {
                const study = studies[0];
                if (!this.exists(study.id)) {
                    this.datasetService.getDatasets(study.id, [DatasetTypeEnum.MEANS, DatasetTypeEnum.SUMMARY_STATISTICS_DATA]).subscribe(
                        (res: HttpResponse<DatasetModel[]>) => {
                            if (!res.body || res.body.length === 0) {
                                this.alertService.error('multi-site-analysis.validation.no.means.dataset', { param: study.name });
                            } else if (res.body.filter((dataset) => dataset.datasetTypeId === DatasetTypeEnum.MEANS).length === 0) {
                                this.alertService.error('multi-site-analysis.validation.no.means.dataset', { param: study.name });
                            } else if (res.body.filter((dataset) => dataset.datasetTypeId === DatasetTypeEnum.SUMMARY_STATISTICS_DATA).length === 0) {
                                this.alertService.error('multi-site-analysis.validation.no.summary.stats.dataset', { param: study.name });
                            } else {
                                this.validateMeansDatasetHasAnalysisVariables(study, res.body[0].datasetId);
                            }
                        }
                    );
                } else {
                    this.openStudy(study);
                }
            }
            this.activeModal.close();
        }, () => {
        });
    }

    validateMeansDatasetHasAnalysisVariables(study: any, meansDatasetId: number) {
        this.datasetService.getObservationSetColumns(study.id, meansDatasetId).subscribe(
            (res: HttpResponse<ObservationVariable[]>) => {
                const analysisVariables = res.body.filter((variable) =>
                    variable.variableType?.toString() === VariableTypeEnum[VariableTypeEnum.ANALYSIS]);
                if (analysisVariables && analysisVariables.length > 0) {
                    this.tabs.push(new NavTab(study.id, study.name, false));
                    this.openStudy(study);
                } else {
                    this.alertService.error('multi-site-analysis.validation.no.analysis.variables', { param: study.name });
                }
            }
        );
    }

    openStudy(study: any) {
        this.setActive(study.id);
        this.router.navigate([`/multi-site-analysis/study/${study.id}`], {
            queryParams: {
                studyId: study.id,
                studyName: study.name
            },
            queryParamsHandling: 'merge'
        });
    }

    setActive(studyId: number) {
        this.tabs.forEach((tab: NavTab) => {
            tab.active = (tab.id === studyId);
        });
    }

    private exists(studyId: number) {
        return this.tabs.some((tab: NavTab) => tab.id === studyId);
    }

    closeTab(tab: NavTab) {
        this.tabs.splice(this.tabs.indexOf(tab), 1);
        if (tab.active && this.tabs.length) {
            this.setActive(this.tabs[0].id);
            this.router.navigate([`/multi-site-analysis/study/${this.tabs[0].id}`], {
                queryParams: {
                    studyId: this.tabs[0].id,
                    studyName: this.tabs[0].name
                },
                queryParamsHandling: 'merge'
            });
        } else {
            this.router.navigate(['/multi-site-analysis'], { queryParamsHandling: 'merge' });
        }
    }

    trackId(index: number, item: NavTab) {
        return item.id;
    }
}
